import React from 'react'
import t from '../../../../../translations/main'
import utils from '../../../../../components/Organisms/Form/utils'
import globalConfig from 'src/components/Organisms/Form/config'

import { ExternalLink } from 'src/components/Core/Styles/Link'
import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import { ConfigCompanyDetails } from '../CompanyDetails/types'
import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'

export const cosecLink = <ExternalLink paddingBottom='0' href='https://www.elementalcosec.com/terms-and-conditions-of-service/terms-and-conditions-for-process-agent-service/' />

const config = ({ countryTelephoneCodes }: ConfigCompanyDetails) => utils.injectTranslation({
  id: 'UkProcessAgentForm',
  path: 'onboarding.forms.CorporateAccount.UkProcessAgentForm.inputs',
  keysToRemove: ['visual'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px'
      },
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'inUK',
            margin: '8px 0 0 0',
            dataList: [
              {
                id: 'inUK1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'inUK2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeAppointment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeElemental',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'break-spaces',
            },
            translationComponent: {cosecLink, requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeProvideContactInformation',
            labelProps: {
              labelHeight: 'auto',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'weAgreeSucdenToPayFees',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelDisplay: 'inline-block',
              labelWhiteSpace: 'pre-wrap',
            },
            translationComponent: {requiredMark: <RequiredMark />},
            required: true,
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'companyName',
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'companyNumber',
            removeLabelEllipsis: true,
            required: true,
          },
        }
      ]
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'input',
          props: {
            name: 'registeredOffice',
            removeLabelEllipsis: true,
            required: true,
            isTextarea: true,
            textAreaHeight: '32px',
            textAreaPointerEvents: 'auto',
            resize: 'none'
          },
        }
      ]
    },
    {
      componentType: 'grid',
      content: [
        {
          componentType: 'radioGroup',
          props: {
            name: 'addressIsDifferent',
            dataList: [
              {
                id: 'inUK1',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'inUK2',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'correspondenceAddress',
            removeLabelEllipsis: true,
            required: true,
            isTextarea: true,
            textAreaHeight: '32px',
            textAreaPointerEvents: 'auto',
            resize: 'none'
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginBottom: '8px',
        gridTemplateColumns: '1fr 1fr'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'contactName',
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'input',
          submitValidation: 'email',
          props: {
            name: 'contactEmailAddress',
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'contactPhoneNumberCountryIndex',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countryTelephoneCodes,
            name: 'contactPhoneNumberCountryIndex',
            label: 'onboarding.forms.CorporateAccount.UkProcessAgentForm.inputs.contactPhoneNumberCountryIndex.label',
            placeholder: 'onboarding.forms.CorporateAccount.UkProcessAgentForm.inputs.contactPhoneNumberCountryIndex.placeholder',
            required: true,
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          transformType: 'transformValidationTelephoneCodePlusNumber',
          props: {
            name: 'validationTelephoneCountryIndexUk',
            show: false,
          },
        },
        {
          componentType: 'input',
          submitValidation: 'telephoneWithMinimum',
          transformType: 'transformTelephoneNumber',
          props: {
            name: 'contactPhoneNumber',
            pattern: globalConfig?.regex?.telephoneNoPlusSignal255,
            removeLabelEllipsis: true,
            required: true,
          },
        },
      ]
    }
  ],
})

export default config
